// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"116":"Play","987":"Lobby"}[chunkId] + "." + {"116":"8e6195cd","987":"d19d5cfe"}[chunkId] + ".chunk.css";
};